export default "__VITE_ASSET__BcI4ov69__"